import { Button, MessageBox, MessageBoxType } from '@ui5/webcomponents-react';
import { useTranslation } from 'react-i18next';

import ButtonDesign from '@ui5/webcomponents/dist/types/ButtonDesign.js';

export type BatchAssignMessageBoxProps = {
  batchAssignNonNewQuery: boolean;
  setBatchAssignNonNewQuery: (value: boolean) => void;
  setIsAssignDialogOpen: (value: boolean) => void;
};

export const BatchAssignMessageBox: React.FC<BatchAssignMessageBoxProps> = (props) => {
  const { batchAssignNonNewQuery, setBatchAssignNonNewQuery, setIsAssignDialogOpen } = props;
  const { t } = useTranslation();

  const handleNo = () => {
    setIsAssignDialogOpen(false);
    setBatchAssignNonNewQuery(false);
  };

  const handleYes = () => {
    setIsAssignDialogOpen(true);
    setBatchAssignNonNewQuery(false);
  };

  return (
    <MessageBox
      data-testid="batch-assign-warning"
      titleText="Confirm Query Reassignment"
      open={batchAssignNonNewQuery}
      type={MessageBoxType.Warning}
      onClose={() => setBatchAssignNonNewQuery(false)}
      actions={[
        <>
          <Button
            design={ButtonDesign.Emphasized}
            onClick={handleYes}
            data-testid="batch-assign-yes"
          >
            Yes
          </Button>
          <Button
            design={ButtonDesign.Transparent}
            onClick={handleNo}
            data-testid="batch-assign-no"
          >
            No
          </Button>
        </>
      ]}
    >
      {t('batch-assign-warning-text')}
      <br />
      {t('batch-assign-warning-question')}
    </MessageBox>
  );
};
